export const FETCH_TRAINER_APPLY = 'FETCH_TRAINER_APPLY';
export const FETCH_COACH = 'FETCH_COACH';
export const SEARCH_COACH = 'SEARCH_COACH';
export const BIND_COACH = 'BIND_COACH';



// WEBPACK FOOTER //
// ./src/store/trainer_apply/types.js